import { render, staticRenderFns } from "./AppWorkspaceMobile.html?vue&type=template&id=7ca9b56e&external"
import script from "./AppWorkspaceMobile.js?vue&type=script&lang=js&external"
export * from "./AppWorkspaceMobile.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import VCard from '@/agilis/wrappers/VCard/VCard.vue'
installComponents(component, {VCard})
